// extracted by mini-css-extract-plugin
export default {"base":"DialogSupportComplete_base__sGHrB","content":"DialogSupportComplete_content__SX5lQ"};